import request from "@utils/request";
import qs from "qs";

/**
 * 用户登录
 * @param data object 用户账号密码
 */
export function login(data) {
  return request.post(
    "/wap/user/login",
    qs.stringify({ username: data.account, password: data.password }),
    { login: false }
  );
}

/**
 * 用户手机号登录
 * @param data object 用户手机号 也只能
 */
export function loginMobile(data) {
  return request.post("/wap/login/mobile", qs.stringify(data), {
    login: false,
  });
}

/**
 * 用户发送验证码
 * @param data object 用户手机号
 */
export function registerVerify(data) {
  return request.post("/wap/register/verify", qs.stringify(data), {
    login: false,
  });
}

/**
 * 用户手机号注册
 * @param data object 用户手机号 验证码 密码
 */
export function register(data) {
  return request.post("/wap/register", qs.stringify(data), { login: false });
}

/**
 * 用户手机号修改密码
 * @param data object 用户手机号 验证码 密码
 */
export function registerReset(data) {
  return request.post("/wap/pwd/reset", qs.stringify(data), { login: false });
}
/**
 * 上传base64图片接口
 * @param applyId
 */
export function uploadImage(param) {
  return request.post(`/upload/image`, qs.stringify(param), { login: false });
}

/*
 * 领取优惠券列表
 * */
export function getCoupon(q) {
  return request.get("/wap/coupons", q, { login: false });
}

/*
 * 点击领取优惠券
 * */
export function getCouponReceive(id) {
  // 第三参才是配置项，第二参是请求体；此前把 {login:true} 当请求体发送
  return request.post(`/wap/coupon/receive/${id}`, {}, { login: true });
}

/*
 * 批量领取优惠券
 * */
export function couponReceiveBatch(couponId) {
  return request.post("/coupon/receive/batch", { couponId });
}

/*
 * 我的优惠券
 * */
export function getCouponsUser() {
  return request.post("/wap/coupons/user");
}

/*
 * 查询商品优惠券
 * */
export function getProductCoupons(cartGoods) {
  return request.post("/wap/product/coupons", cartGoods, { login: false });
}

/*
 * 获取门店用户
 */
export function getShopUser(shopId, openId) {
  return request.get(`/wap/user/info/${shopId}/${openId}`);
}
/*
 * 个人中心
 */
export function getUser() {
  return request.get("/wap/user/info");
}

/*
 * 用户信息
 */
export function getUserInfo() {
  return request.get("/wap/userinfo");
}

/*
 * 地址列表
 * */
export function getAddressList(data) {
  return request.post("/wap/address/list", data || {});
}

/*
 * 删除地址
 * */
export function getAddressRemove(id) {
  return request.post("/wap/address/del/" + id);
}

/*
 * 设置默认地址
 * */
export function getAddressDefaultSet(id) {
  return request.post("/wap/address/default/set/" + id);
}

/*
 * 获取默认地址
 * */
export function getAddressDefault() {
  return request.get("/wap/address/default");
}

/*
 * 获取单个地址
 * */
export function getAddress(id) {
  return request.get("/wap/address/detail/" + id);
}

/*
 * 修改 添加地址
 * */
export function postAddress(data) {
  return request.post("/wap/address/edit", data);
}

/*
 * 获取收藏产品
 * */
export function getCollectUser(page, limit) {
  return request.get("/wap/collect/user", { page: page, limit: limit });
}

/*
 * 删除收藏产品
 * */
export function getCollectDel(id) {
  return request.post("/wap/collect/del/" + id);
}

/*
 * 批量收藏产品
 * */
export function postCollectAll(data) {
  return request.post("/collect/all", data);
}

/*
 * 添加收藏产品
 * */
export function collectAdd(id) {
  return request.post("/wap/collect/add/" + id);
}

/*
 * 查询收藏产品
 * */
export function getUserCollect(id) {
  return request.post("/wap/collect/user/" + id, { login: true });
}

/*
 * 签到配置
 * */
export function getSignConfig() {
  return request.get("/wap/sign/config");
}

/*
 * 签到里的签到列表
 * */
export function getSignList(page, limit) {
  return request.get("/wap/sign/list", { pageNO: page, pageSize: limit });
}

/*
 * 签到列表
 * */
export function getSignMonth(page, limit) {
  return request.get("/wap/sign/month", { pageNO: page, pageSize: limit });
}

/*
 * 签到用户信息
 * */
export function postSignUser(sign) {
  return request.get("/wap/sign/user", sign);
}

/*
 * 签到
 * */
export function postSignIntegral(sign) {
  return request.post("/wap/sign/integral", sign);
}

/*
 * 推广数据
 * */
export function getSpreadInfo() {
  return request.get("/commission");
}

/*
 * 推广人列表
 * */
export function getSpreadUser(page) {
  return request.post("/wap/spread/people", page);
}

/*
 * 推广人订单
 * */
export function getSpreadOrder(where) {
  return request.post("/wap/spread/order", where);
}

/*
 * 资金明细（types|0=全部,1=消费,2=充值,3=返佣,4=提现）
 * */
export function getCommissionInfo(q, types) {
  return request.post("/wap/spread/commission/" + types, q);
}

/*
 * 积分记录
 * */
export function getIntegralList(q) {
  return request.post("/wap/member/integral/list", {
    pageNO: q.page,
    pageSize: q.limit,
  });
}

/*
 * 积分统计
 * */
export function getIntegralUser() {
  return request.get("/wap/integral/user");
}

/*
 * 提现银行
 * */
export function getBank() {
  return request.get("/extract/bank");
}

/*
 * 提现申请
 * */
export function postCashInfo(cash) {
  return request.post("/extract/cash", cash);
}

/*
 * 会员中心
 * */
export function getVipInfo() {
  return request.post("/wap/grade");
}

/*
 * 会员等级任务
 * */
export function getVipTask(id) {
  return request.post("/wap/user/level/task/" + id);
}

/*
 * 会员等级任务
 * */
export function getUserVipInfo() {
  return request.post("/wap/user/level");
}

/*
 * 资金统计
 * */
export function getBalance() {
  return request.get("/user/balance");
}

/*
 * 活动状态
 * */
export function getActivityStatus() {
  return request.get("/user/activity", {}, { login: false });
}

/*
 * 活动状态
 * */
export function getSpreadImg() {
  return request.get("/wap/spread/banner");
}
/*
 * 获取会员余额
 * */
export function getArrivalData() {
  return request.get("/wap/user/arrival");
}

/*
 * 获取用户绑定的门店
 * */
export function getUserShop() {
  return request.get("/wap/user/shop");
}
/*
 * 切换用户
 * */
export function switchUser(accountId) {
  return request.get(`/wap/user/switch/${accountId}`, {}, { login: true });
}
/*
 * 用户修改信息
 * */
export function postUserEdit(data) {
  return request.post("/wap/user/edit", qs.stringify(data));
}

/*
 * 用户修改信息
 * */
export function getChatRecord(to_uid, data) {
  return request.get("user/service/record/" + to_uid, data);
}

/*
 * 用户修改信息
 * */
export function serviceList() {
  return request.get("user/service/list");
}

/*
 * 公众号充值
 * */
export function rechargeWechat(data) {
  return request.post("/recharge/wechat", data);
}

/*
 * 退出登录
 * */
export function getLogout() {
  return request.get("/logout");
}

/*
 * 绑定手机号
 * */
export function bindingPhone(data) {
  return request.post("/wap/user/bind", qs.stringify(data));
}
/*
 * 绑定门店
 * */
export function bindingShop(data) {
  return request.post("/wap/user/shop/bind", qs.stringify(data));
}

/*
 * h5切换公众号登陆
 * */
export function switchH5Login() {
  return request.post("switch_h5", { from: "wechat" });
}
/*
 * 获取推广人排行
 * */
export function getRankList(q) {
  return request.post("/wap/spread/rank", q);
}
/*
 * 获取佣金排名
 * */
export function getBrokerageRank(q) {
  return request.post("/wap/spread/brokerage/rank", q);
}
/**
 * 检测会员等级
 */
export function setDetection() {
  return request.get("/wap/user/level/detection");
}
/**
 * 获取推广人信息
 */
export function getSpreadAccount() {
  return request.post("/wap/spread/get");
}
